import Stricky from "./stricky";

function install(Vue) {
  Vue.directive("stricky", Stricky);
}

if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}
Stricky.install = install;
export default Stricky;
